import { SALARY_FUND } from "../../data/site";
import { useLanguage } from "../../i18n/LanguageContext";
import { CountUp } from "./CountUp";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";

const SEG_COLORS = ["bg-white/70", "bg-nx-blue", "bg-nx-lime"];
const NUM_COLORS = ["text-nx-text", "text-nx-blue", "text-nx-lime"];

export const SalaryFund = () => {
    const { t } = useLanguage();
    return (
        <section data-testid="salary-fund-section" className="border-t border-white/5 bg-nx-alt py-20 sm:py-24 lg:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
                <SectionHeader
                    label={t("Monthly Salary Fund")}
                    testId="salary-fund"
                    title={<>{t("Monthly Salary Fund")}</>}
                    description={t("10% of every level purchase network-wide is set aside automatically into the Monthly Salary Fund and released to qualifying leaders and active members every month.")}
                />

                <Reveal delay={0.15} className="mt-12">
                    <div className="flex h-3 w-full overflow-hidden rounded-full" data-testid="salary-fund-bar" role="img" aria-label="Salary fund distribution: 35% top 50 leaders, 20% level 2 to 6, 45% level 7 to 12">
                        {SALARY_FUND.map((s, i) => (
                            <div key={s.title} className={`${SEG_COLORS[i]} h-full`} style={{ width: `${s.pct}%` }} />
                        ))}
                    </div>
                </Reveal>

                <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3 lg:gap-5">
                    {SALARY_FUND.map((s, i) => (
                        <Reveal key={s.title} delay={0.1 + i * 0.08}>
                            <div className="h-full rounded-2xl border border-white/5 bg-nx-elev p-7 transition-all duration-300 hover:-translate-y-0.5 hover:border-white/10 lg:p-8" data-testid={`salary-tier-${i + 1}`}>
                                <CountUp to={s.pct} suffix="%" testId={`salary-pct-${i + 1}`} className={`text-5xl font-extrabold tracking-tight tabular ${NUM_COLORS[i]}`} />
                                <h3 className="mt-3 text-xs font-extrabold uppercase tracking-[0.18em] text-nx-text">{t(s.title)}</h3>
                                <p className="mt-3 text-sm leading-relaxed text-nx-sub">{t(s.desc)}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.25} className="mt-6">
                    <p className="text-xs leading-relaxed text-nx-mute" data-testid="salary-fund-note">
                        {t("Distribution is processed automatically every month. All conditions must be met to be eligible for distribution.")}
                    </p>
                </Reveal>
            </div>
        </section>
    );
};
